<template>
  <div>
    <div class="h-full h-screen" ref="iframeContainer">
      <iframe v-if="emailSignupUrl" frameborder="0" :src="emailSignupUrl" class="w-full h-full" load="load"></iframe>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  middleware: 'auth',
  layout: 'defaultTinyEmail',
  data() {
    return {
      showUseGrooveFree: false,
    };
  },
  computed: {
    emailSignupUrl() {
      const tinyBaseUrl = 'https://app.tinyemail.com/sign-up';
      let tinyParams = {
        utm_source: 'GROOVE',
        planCode: 'GROOVE_PRO',
        subscriptionType: 'month',
        email: this.$store.state.user.email
      };

      const queryString = new URLSearchParams(tinyParams).toString();
      return `${tinyBaseUrl}?${queryString}`;
    }
  },
  async created() {
    //
  },
};
</script>
